export enum scoutsEntryTypes {
  FETCH_SCOUTS_ENTRY_REQUEST = "FETCH_SCOUTS_ENTRY_REQUEST",
  FETCH_SCOUTS_ENTRY_SUCCESS = "FETCH_SCOUTS_ENTRY_SUCCESS",
  FETCH_SCOUTS_ENTRY_FAILURE = "FETCH_SCOUTS_ENTRY_FAILURE",
}